import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MetadataService {
  API_SERVER: string = environment.baseApiUrl;

  constructor(
    private httpClient: HttpClient,
  ) { }

  private extractData(res: Response | HttpEvent<any>) {
    const body = res;
    return body || {};
  }

  upload(data, opts?: any): Observable<any> {
    let headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Origin', '*');
    opts = { ...opts, ...headers }

    return this.httpClient.post<any>(this.API_SERVER + 'metadata', data, opts).pipe(
      map(res => this.extractData(res))
    )
  }
}
